var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExamEvaluationImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun_exam_4213786",
    xmlns: "http://www.w3.org/2000/svg",
    width: 76.198,
    height: 76.097,
    viewBox: "0 0 76.198 76.097",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1598",
    "data-name": "Group 1598",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41919",
    "data-name": "Path 41919",
    d: "M194.229,74.39a.776.776,0,0,1-.74-1.019l2.587-7.864a.775.775,0,0,1,.191-.31l37.525-37.175a4.426,4.426,0,1,1,6.208,6.3L202.476,71.491a.753.753,0,0,1-.292.181l-7.706,2.672a.755.755,0,0,1-.248.047Zm3.262-8.221-2.031,6.208,6.056-2.1,37.4-37.051a2.869,2.869,0,0,0-2-4.915h-.018a2.846,2.846,0,0,0-2.018.825ZM201.94,70.942Z",
    transform: "translate(-165.272 -24.314)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41920",
    "data-name": "Path 41920",
    d: "M440.515,57.741a.776.776,0,0,1-.551-.228l-5.05-5.052a.776.776,0,1,1,1.1-1.1l5.052,5.052a.776.776,0,0,1-.551,1.324Z",
    transform: "translate(-369.046 -44.905)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41921",
    "data-name": "Path 41921",
    d: "M407.615,90.641a.776.776,0,0,1-.548-.228l-5.052-5.052a.776.776,0,1,1,1.1-1.1l5.052,5.05a.776.776,0,0,1-.551,1.324Z",
    transform: "translate(-341.255 -72.696)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41922",
    "data-name": "Path 41922",
    d: "M216.66,279.547a.776.776,0,0,1-.548-.228l-5.008-5.008a.776.776,0,1,1,1.1-1.1l5.011,5.011a.776.776,0,0,1-.551,1.324Z",
    transform: "translate(-179.994 -232.301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41923",
    "data-name": "Path 41923",
    d: "M57.425,81.972H22.637a.776.776,0,0,1-.776-.776l-.078-9.085H12.776A.776.776,0,0,1,12,71.335V11.776A.776.776,0,0,1,12.776,11H74.9a.776.776,0,0,1,.776.776v9.4a.776.776,0,1,1-1.552,0V12.552H13.552v58h9.007a.776.776,0,0,1,.776.776l.072,9.085H57.42a.776.776,0,0,1,0,1.552Z",
    transform: "translate(-12 -11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41924",
    "data-name": "Path 41924",
    d: "M412.776,161.18A.776.776,0,0,1,412,160.4V139.776a.776.776,0,1,1,1.552,0V160.4a.776.776,0,0,1-.776.779Z",
    transform: "translate(-349.88 -119.123)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41925",
    "data-name": "Path 41925",
    d: "M23.406,407.182a.776.776,0,0,1-.551-.228l-9.7-9.714a.776.776,0,0,1,1.086-1.087l9.706,9.706a.776.776,0,0,1-.543,1.319Z",
    transform: "translate(-12.846 -336.212)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41926",
    "data-name": "Path 41926",
    d: "M285.59,303.34a18.17,18.17,0,1,1,18.17-18.17,18.17,18.17,0,0,1-18.17,18.17Zm0-34.788a16.618,16.618,0,1,0,16.618,16.618,16.618,16.618,0,0,0-16.618-16.618Z",
    transform: "translate(-227.753 -227.243)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41927",
    "data-name": "Path 41927",
    d: "M306.22,320.175A14.378,14.378,0,1,1,320.6,305.8a14.378,14.378,0,0,1-14.378,14.378Zm0-27.2A12.826,12.826,0,1,0,319.045,305.8a12.826,12.826,0,0,0-12.826-12.826Z",
    transform: "translate(-248.378 -247.871)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41928",
    "data-name": "Path 41928",
    d: "M388.313,328.394a.776.776,0,0,1-.409-.116L379.367,323a.776.776,0,0,1-.367-.66V311.776a.776.776,0,1,1,1.552,0V321.9l8.174,5.055a.776.776,0,0,1-.409,1.436Z",
    transform: "translate(-322.004 -264.411)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41929",
    "data-name": "Path 41929",
    d: "M424.887,73.369a.776.776,0,0,1-.548-.228l-5.052-5.049a.776.776,0,1,1,1.1-1.1l5.047,5.06a.776.776,0,0,1-.551,1.327Z",
    transform: "translate(-355.839 -58.107)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41930",
    "data-name": "Path 41930",
    d: "M441.816,382.552H441A.776.776,0,1,1,441,381h.82a.776.776,0,1,1,0,1.552Z",
    transform: "translate(-373.718 -323.539)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41931",
    "data-name": "Path 41931",
    d: "M315.1,382.552h-.82a.776.776,0,1,1,0-1.552h.82a.776.776,0,1,1,0,1.552Z",
    transform: "translate(-266.678 -323.539)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41932",
    "data-name": "Path 41932",
    d: "M380.276,444.092a.776.776,0,0,1-.776-.776v-.82a.776.776,0,1,1,1.552,0v.82A.776.776,0,0,1,380.276,444.092Z",
    transform: "translate(-322.427 -374.83)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41933",
    "data-name": "Path 41933",
    d: "M432.819,349.977a.776.776,0,0,1-.39-1.449l.709-.411a.776.776,0,0,1,.776,1.343l-.709.411A.775.775,0,0,1,432.819,349.977Z",
    transform: "translate(-366.808 -295.69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41934",
    "data-name": "Path 41934",
    d: "M323.159,413.394a.776.776,0,0,1-.39-1.448l.709-.411a.776.776,0,1,1,.776,1.345l-.709.409A.776.776,0,0,1,323.159,413.394Z",
    transform: "translate(-274.177 -349.243)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41935",
    "data-name": "Path 41935",
    d: "M411.118,435.811a.776.776,0,0,1-.673-.388l-.411-.709a.776.776,0,0,1,1.345-.776l.409.709a.776.776,0,0,1-.67,1.167Z",
    transform: "translate(-348.131 -367.927)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41936",
    "data-name": "Path 41936",
    d: "M347.7,326.305a.776.776,0,0,1-.675-.388l-.411-.709a.776.776,0,0,1,1.343-.776l.411.716a.776.776,0,0,1-.67,1.167Z",
    transform: "translate(-294.578 -275.451)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41937",
    "data-name": "Path 41937",
    d: "M410.566,326.061a.776.776,0,0,1-.673-1.164l.409-.711a.778.778,0,1,1,1.348.776l-.411.711a.776.776,0,0,1-.673.388Z",
    transform: "translate(-348.014 -275.216)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41938",
    "data-name": "Path 41938",
    d: "M347.352,435.889a.776.776,0,0,1-.673-1.164l.409-.711a.777.777,0,0,1,1.345.776l-.409.711a.776.776,0,0,1-.673.388Z",
    transform: "translate(-294.617 -368.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41939",
    "data-name": "Path 41939",
    d: "M323.782,350.034a.774.774,0,0,1-.385-.1l-.712-.409a.778.778,0,1,1,.776-1.348l.711.409a.776.776,0,0,1-.388,1.449Z",
    transform: "translate(-274.107 -295.723)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41940",
    "data-name": "Path 41940",
    d: "M117.146,363.415a5.18,5.18,0,0,1-1.359-.181,8.376,8.376,0,0,1-2.875-1.655,4.714,4.714,0,0,0-3.19-1.433,4.266,4.266,0,0,0-3.179,2.664.776.776,0,1,1-1.4-.672,5.569,5.569,0,0,1,4.462-3.539,6.12,6.12,0,0,1,4.255,1.754,7.14,7.14,0,0,0,2.328,1.384,3.585,3.585,0,0,0,2.3-.122,5.386,5.386,0,0,1-.631-.572,3.973,3.973,0,0,1-1.035-3.971,3.635,3.635,0,0,1,2.83-2.778,2.926,2.926,0,0,1,2.871,1.278,4.266,4.266,0,0,1-.259,4.615,7.4,7.4,0,0,1-.836,1.166,9.287,9.287,0,0,0,4.814-.041.776.776,0,0,1,.378,1.506,10.632,10.632,0,0,1-6.542-.292,5.385,5.385,0,0,1-2.933.89Zm2.931-7.6a1.265,1.265,0,0,0-.2.016,2.168,2.168,0,0,0-1.575,1.707,2.431,2.431,0,0,0,.685,2.445,4.4,4.4,0,0,0,.913.722,5.867,5.867,0,0,0,1.035-1.293,2.817,2.817,0,0,0,.31-2.962,1.4,1.4,0,0,0-1.154-.634Z",
    transform: "translate(-90.599 -300.956)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41941",
    "data-name": "Path 41941",
    d: "M68.984,54.552H46.776a.776.776,0,1,1,0-1.552H68.984a.776.776,0,1,1,0,1.552Z",
    transform: "translate(-40.72 -46.479)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41942",
    "data-name": "Path 41942",
    d: "M64.325,79.552H46.776a.776.776,0,0,1,0-1.552H64.325a.776.776,0,0,1,0,1.552Z",
    transform: "translate(-40.72 -67.596)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41943",
    "data-name": "Path 41943",
    d: "M120.325,119.552H102.776a.776.776,0,1,1,0-1.552h17.549a.776.776,0,0,1,0,1.552Z",
    transform: "translate(-88.023 -101.382)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41944",
    "data-name": "Path 41944",
    d: "M115.193,142.552H102.776a.776.776,0,1,1,0-1.552h12.417a.776.776,0,1,1,0,1.552Z",
    transform: "translate(-88.023 -120.812)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41945",
    "data-name": "Path 41945",
    d: "M51.9,123.677H46.776A.776.776,0,0,1,46,122.9v-5.125a.776.776,0,0,1,.776-.776H51.9a.776.776,0,0,1,.776.776V122.9a.776.776,0,0,1-.776.776Zm-4.348-1.552h3.572v-3.572H47.552Z",
    transform: "translate(-40.72 -100.537)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41946",
    "data-name": "Path 41946",
    d: "M306.493,119.552H295.776a.776.776,0,0,1,0-1.552h10.715a.776.776,0,1,1,0,1.552Z",
    transform: "translate(-251.05 -101.382)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41947",
    "data-name": "Path 41947",
    d: "M302.921,142.552h-7.145a.776.776,0,0,1,0-1.552h7.145a.776.776,0,1,1,0,1.552Z",
    transform: "translate(-251.05 -120.812)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41948",
    "data-name": "Path 41948",
    d: "M244.9,123.677h-5.125A.776.776,0,0,1,239,122.9v-5.124a.776.776,0,0,1,.776-.776H244.9a.776.776,0,0,1,.776.776V122.9a.776.776,0,0,1-.776.776Zm-4.349-1.552h3.572v-3.572h-3.572Z",
    transform: "translate(-203.747 -100.537)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41949",
    "data-name": "Path 41949",
    d: "M120.325,183.552H102.776a.776.776,0,0,1,0-1.552h17.549a.776.776,0,0,1,0,1.552Z",
    transform: "translate(-88.023 -155.444)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41950",
    "data-name": "Path 41950",
    d: "M124.674,206.552h-21.9a.776.776,0,1,1,0-1.552h21.9a.776.776,0,1,1,0,1.552Z",
    transform: "translate(-88.023 -174.871)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41951",
    "data-name": "Path 41951",
    d: "M51.9,187.677H46.776A.776.776,0,0,1,46,186.9v-5.125a.776.776,0,0,1,.776-.776H51.9a.776.776,0,0,1,.776.776V186.9A.776.776,0,0,1,51.9,187.677Zm-4.348-1.552h3.572v-3.572H47.552Z",
    transform: "translate(-40.72 -154.599)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41952",
    "data-name": "Path 41952",
    d: "M119.073,247.552h-16.3a.776.776,0,0,1,0-1.552h16.3a.776.776,0,0,1,0,1.552Z",
    transform: "translate(-88.023 -209.505)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41953",
    "data-name": "Path 41953",
    d: "M115.193,270.552H102.776a.776.776,0,0,1,0-1.552h12.417a.776.776,0,1,1,0,1.552Z",
    transform: "translate(-88.023 -228.933)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41954",
    "data-name": "Path 41954",
    d: "M51.9,251.677H46.776A.776.776,0,0,1,46,250.9v-5.124a.776.776,0,0,1,.776-.776H51.9a.776.776,0,0,1,.776.776V250.9a.776.776,0,0,1-.776.776Zm-4.348-1.552h3.572v-3.572H47.552Z",
    transform: "translate(-40.72 -208.66)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41955",
    "data-name": "Path 41955",
    d: "M114.114,311.552H102.776a.776.776,0,1,1,0-1.552h11.338a.776.776,0,1,1,0,1.552Z",
    transform: "translate(-88.023 -263.566)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41956",
    "data-name": "Path 41956",
    d: "M109.145,334.552h-6.369a.776.776,0,1,1,0-1.552h6.366a.776.776,0,1,1,0,1.552Z",
    transform: "translate(-88.023 -282.994)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41957",
    "data-name": "Path 41957",
    d: "M51.9,315.677H46.776A.776.776,0,0,1,46,314.9v-5.125a.776.776,0,0,1,.776-.776H51.9a.776.776,0,0,1,.776.776V314.9A.776.776,0,0,1,51.9,315.677Zm-4.348-1.552h3.572v-3.572H47.552Z",
    transform: "translate(-40.72 -262.721)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41958",
    "data-name": "Path 41958",
    d: "M288.015,58.432H270.776a.776.776,0,0,1-.776-.776v-3.88a.776.776,0,0,1,.776-.776h17.239a.776.776,0,0,1,.776.776v3.88A.776.776,0,0,1,288.015,58.432ZM271.552,56.88h15.687V54.552H271.552Z",
    transform: "translate(-229.933 -46.479)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExamEvaluationImg);
export default __webpack_public_path__ + "static/media/examEvaluation-img.dac98f072edb49d1375384c8c882bde3.svg";
export { ForwardRef as ReactComponent };